import {
  getWebToken,
  syncUserInfo,
  getUserId,
  removeUserInfo,
  syncOrgId
} from '@/common/utils/common'

const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: () => getWebToken && getWebToken(),
  uid: () => getUserId && Number(getUserId()),
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userCurrentOrg: state => state.user.userCurrentOrg,
  userOrgList: state => state.user.userOrgList,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog && state.errorLog.logs,
  currentShop: state => state.user.currentShop,
  shopInfoList: state => state.user.shopInfoList
}
export default getters
